import {
  LOAD_SUCCESS_SOCIETES,
  LOAD_FAIL_SOCIETES,
  SAVE_SUCCESS_SOCIETES,
  SAVE_FAIL_SOCIETES,
  UPDATE_SUCCESS_SOCIETES,
  UPDATE_FAIL_SOCIETES,
  DELETE_SUCCESS_SOCIETES,
  DELETE_FAIL_SOCIETES,
  INCREMENT_SUCCESS_SOCIETES,
  INCREMENT_FAIL_SOCIETES,
} from "../actions/societeAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_SOCIETES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_SOCIETES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_SOCIETES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_SOCIETES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_SOCIETES:
      const updatedListe = [];
      state.data.forEach((item) => {
        if (item.societe_id === action.payload.societe_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_SOCIETES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_SOCIETES:
      const filtered = state.data.filter((etape) => {
        return etape.societe_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_SOCIETES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case INCREMENT_SUCCESS_SOCIETES:
      if (!state.data) return state;

      return {
        ...state,
        loading: false,
        loaded: true,
        data: state.data.map((item) =>
          item.societe_id === action.payload.societe_id ? action.payload : item
        ),
        error: null,
      };
    case INCREMENT_FAIL_SOCIETES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
